import React, { forwardRef } from 'react'
import { Box, Autocomplete } from '@material-ui/core'
import { CoreTextField } from '../'
import PropTypes from 'prop-types'
import styled from 'styled-components' // Import styled-components
import { Icon } from '@iconify/react'

const BaseAutoComplete = styled(Autocomplete)`
  margin-top: ${({ marginTop }) => (marginTop ? '20px' : '0px')};
  .MuiFormControl-root {
    margin-top: 0px;
  }
`

// CoreAutoComplete component with forwardRef
const CoreAutoComplete = forwardRef(
  (
    {
      id = 'auto-complete',
      options = [],
      variant = 'outlined',
      size = 'medium',
      color = 'primary', // Add color prop with default 'primary'
      fullWidth = false,
      freeSolo = true,
      error = false,
      helperText,
      label,
      placeholder,
      title,
      marginTop = true,
      ...props
    },
    ref,
  ) => {
    return (
      <BaseAutoComplete
        id={id}
        marginTop={marginTop}
        sx={{
          width: '100%',
          borderRadius: '6px',
        }}
        freeSolo={freeSolo}
        options={options}
        autoHighlight
        getOptionLabel={option => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option
          }
          // Regular option
          return option.name
        }}
        renderOption={(props, option) => (
          <Box
            component="li"
            sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
            {...props}
          >
            {option.name}
          </Box>
        )}
        renderInput={params => (
          <CoreTextField
            {...params}
            label={label}
            placeholder={placeholder}
            title={title}
            marginTop={false}
          />
        )}
        popupIcon={
          <Icon
            icon="eva:chevron-down-fill"
            style={{ fontSize: '20px', color: '#637381' }}
          />
        }
        {...props}
      />
    )
  },
)

// Prop validation
CoreAutoComplete.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array,
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  size: PropTypes.oneOf(['small', 'medium']),
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'error',
    'info',
    'success',
    'warning',
    'dark',
    'inherit',
  ]), // Add color prop validation
  fullWidth: PropTypes.bool,
  freeSolo: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  marginTop: PropTypes.bool,
}

export default CoreAutoComplete
